import reducer from "./reducers";

import * as ventasTareasOps from "./operations";
import * as ventasTareasTypes from "./types";

export { ventasTareasOps, ventasTareasTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasTareas/index.js